import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Radio } from 'lucide-react';
import { usePublishedFeed } from '../hooks/useCatalog';
import { useLanguage } from '../contexts/LanguageContext';
import { localizeArticle } from '../i18n/translations';

const BreakingNewsTicker = () => {
  const { data: feed = [] } = usePublishedFeed();
  const { lang, t } = useLanguage();
  const articles = feed.slice(0, 10);

  if (articles.length === 0) return null;

  const duplicatedArticles = [...articles, ...articles];

  return (
    <div className="bg-primary text-white overflow-hidden border-b-2 border-primary max-w-full" data-testid="breaking-news-ticker">
      <div className="max-w-[1400px] mx-auto flex items-stretch min-w-0 w-full overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-2 bg-black flex-shrink-0">
          <motion.div
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            <Radio size={16} className="text-red-500" />
          </motion.div>
          <span className="font-label text-xs whitespace-nowrap">{t('breakingNews')}</span>
        </div>
        <div className="overflow-hidden flex-1 relative min-w-0">
          <div className="flex gap-8 py-2 animate-marquee whitespace-nowrap will-change-transform">
            {duplicatedArticles.map((article, idx) => {
              const localized = localizeArticle(article, lang);
              return (
                <Link
                  key={`${article.id}-${idx}`}
                  to={`/article/${article.slug}`}
                  className="text-sm hover:underline flex items-center gap-2"
                >
                  <span className="text-yellow-300">●</span>
                  {localized.displayTitle}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakingNewsTicker;
